/**
 * Header Component
 *
 * Displays the site header with branding and navigation.
 * Logo and colors are configurable per tenant.
 */

import type { ReactElement } from "react";
import { Link, useParams } from "react-router-dom";

export function Header(): ReactElement {
  const { vertical } = useParams<{ vertical?: string }>();

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-surface">
      <div className="container-wide">
        <div className="flex h-16 items-center justify-between">
          {/* Logo / Brand */}
          <Link
            to={vertical ? `/${vertical}` : "/"}
            className="flex items-center gap-2 font-heading text-xl font-semibold text-text-primary hover:text-primary transition-colors"
          >
            <svg
              className="h-8 w-8 text-primary"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <rect x="2" y="2" width="28" height="28" rx="6" className="fill-current" />
              <path
                d="M10 16L14 20L22 12"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>Compare</span>
          </Link>

          {/* Navigation */}
          <nav className="flex items-center gap-4">
            {vertical && (
              <Link
                to={`/${vertical}`}
                className="text-sm text-text-secondary hover:text-text-primary transition-colors"
              >
                Start Over
              </Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
}
